import axios from 'axios'
import { AppHolder } from '@/utils/app-holder'
import humps from 'humps'
import websocket from './modules/websocket'
import CableWrapper from './cable-wrapper'
import clone from 'lodash/cloneDeep'
import store from '@/store'

const client = axios.create({
  baseURL: `${process.env.BASE_URL}/v1`,
  withCredentials: true
})

client.interceptors.request.use(request => {
  request.data = humps.decamelizeKeys(request.data)
  return request
})

const accessToken = store.getters['auth/accessToken']

if (accessToken) {
  // allow to stay authenticated when refreshing the page or if token still valid
  const headers = clone(client.defaults.headers)
  headers.common['Authorization'] = `Bearer ${accessToken}`
  client.defaults.headers = headers
}

client.interceptors.response.use(({data}) => {
  return data instanceof Blob ? data : humps.camelizeKeys(data)
}, error => {
  error = humps.camelizeKeys(error)
  AppHolder.store.dispatch('error/setError', error)

  // TODO : DEVISE ERROR FORMAT TEMPORARY FIX
  if (error.response && error.response.data.error) {
    error.response.data.errors = {global: [error.response.data.error]}
  }

  error.fields = error.response ? error.response.data.errors : []
  throw error
})

export const cable = new CableWrapper(client)
// export const cable = ActionCable.createConsumer(`${process.env.BASE_WEBSOCKET}/cable?toto=45`)

export function requestApi (host) {
  const biApi = axios.create({
    baseURL: host
  })

  biApi.interceptors.request.use(request => {
    request.data = humps.decamelizeKeys(request.data)
    return request
  })

  biApi.interceptors.response.use(({data}) => {
    return humps.camelizeKeys(data)
  }, error => {
    error = humps.camelizeKeys(error)
    AppHolder.store.commit('error/setError', error)

    // TODO : DEVISE ERROR FORMAT TEMPORARY FIX
    if (error.response && error.response.data.error) {
      error.response.data.errors = {global: [error.response.data.error]}
    }

    error.fields = error.response ? error.response.data.errors : []
    throw error
  })

  return biApi
}

export function subscribe (userId) {
  websocket.subscribe(userId)
}

export function unsubscribe () {
  websocket.unsubscribe()
  cable.disconnect()
}

export default client
